<mg-table [collectionComponent]="this" matSort stickyHeaders>

	<ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Status </th>
        <td mat-cell *matCellDef="let row"> {{row.status}} </td>
    </ng-container>

	<ng-container matColumnDef="datum">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Datum </th>
        <td mat-cell *matCellDef="let row"> {{row.datum | date}} </td>
    </ng-container>

</mg-table>
